import React from 'react'
import { WizardProvider as _WizardProvider } from './WizardContext'
import { WizardRenderer } from './WizardRenderer'

/**
 * WizardProvider
 *
 * Wrappa l'applicazione (o una sua parte) fornendo il contesto wizard.
 * Include automaticamente il renderer visuale — non serve aggiungere
 * <WizardRenderer> separatamente.
 *
 * Posizionarlo il più in alto possibile nell'albero (es. root.tsx).
 *
 * @example
 * ```tsx
 * // app/root.tsx
 * import { WizardProvider } from '~/components/wizard'
 *
 * export default function App() {
 *   return (
 *     <WizardProvider>
 *       <Outlet />
 *     </WizardProvider>
 *   )
 * }
 * ```
 */
export function WizardProvider({ children }: { children: React.ReactNode }) {
	return (
		<_WizardProvider>
			{children}
			<WizardRenderer />
		</_WizardProvider>
	)
}

export { useWizard } from './useWizard'
export { WizardButton } from './WizardButton'
export type { WizardConfig, WizardStep, WizardStepPosition } from './types'
